export default __webpack_public_path__ + "static/media/isadora.afb676d4.svg";